import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/index'
import Ref from '@/view/ref'
import privacy from '@/view/privacy'
import agreement from '@/view/agreement'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/index', name: 'Home', component: Home },
    { path: '/ref', name: 'Ref', component: Ref },
		{ path: '/privacy', component: privacy, name: 'privacy'},
		{ path: '/agreement', component: agreement, name: 'agreement'},
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js